import { create } from 'zustand';
import { MonthYearValue } from '../../utils/MonthYear/MonthYearValue';
import { IFutureOrder, IOrderDetails, ISupplierExposure } from '../../sp-types/FutureOrderType';
import { emptyFutureOrder } from '../../pages/FutureOrder/futureOrderUtils';

// Next set function - just need to write a generic setter
interface futureOrderStore {
  editedFutureOrder: IFutureOrder;
  allFutureOrders: IFutureOrder[];
  isFutureOrdersLoading: boolean;
  setIsFutureOrdersLoading: (_value: boolean) => void;
  setAllFutureOrders: (_value: IFutureOrder[]) => void;
  setEditedFutureOrder: (_value: IFutureOrder) => void;
  updateSingleSupplierExposureCalendar: (_materialName: string, _newExposureCalendar: MonthYearValue[]) => void;
  updateFutureOrderProperty: <K extends keyof IFutureOrder>(_property: K, _value: IFutureOrder[K]) => void;
  updateOrderDetailsProperty: <K extends keyof IOrderDetails>(_property: K, _value: IOrderDetails[K]) => void;
  updateSupplierExposure: <K extends keyof ISupplierExposure>(
    _property: K,
    _value: ISupplierExposure[K],
    _index: number,
  ) => void;
  resetStore: () => void;
}

export const useFutureOrderStore = create<futureOrderStore>((set) => ({
  editedFutureOrder: emptyFutureOrder,
  allFutureOrders: [],
  isFutureOrdersLoading: true,
  setIsFutureOrdersLoading: (value: boolean) => set({ isFutureOrdersLoading: value }),
  setEditedFutureOrder: (value: IFutureOrder) => set({ editedFutureOrder: value }),
  setAllFutureOrders: (value: IFutureOrder[]) => set({ allFutureOrders: value }),
  updateFutureOrderProperty: (property, value) =>
    set((state) => ({
      editedFutureOrder: { ...state.editedFutureOrder, [property]: value },
    })),
  updateOrderDetailsProperty: (property, value) =>
    set((state) => ({
      editedFutureOrder: {
        ...state.editedFutureOrder,
        orderDetails: {
          ...state.editedFutureOrder.orderDetails,
          [property]: value,
        },
      },
    })),
  updateSupplierExposure: (property, value, index) =>
    set((state) => ({
      editedFutureOrder: {
        ...state.editedFutureOrder,
        supplierExposure: state.editedFutureOrder.supplierExposure.map((item, i) => {
          if (i === index) {
            return {
              ...item,
              [property]: value,
            };
          }
          return item;
        }),
      },
    })),
  updateSingleSupplierExposureCalendar: (materialName, newExposureCalendar) =>
    set((state) => ({
      editedFutureOrder: {
        ...state.editedFutureOrder,
        supplierExposure: state.editedFutureOrder.supplierExposure.map((material) =>
          material.formulaId === materialName ? { ...material, exposureCalendar: newExposureCalendar } : material,
        ),
      },
    })),
  resetStore: () => set({ editedFutureOrder: emptyFutureOrder }),
}));
